import React from "react";
import withSvgIcon from "~/hocs/with-svg-icon";

export const MoveIcon = withSvgIcon(
    <g>
        <path d="M435 178.5l-17.5 17.9L449 227H261.2V49.2l30.5 31.9 18-17.2L249.3.5l-61.6 63.3 18 17.4 30.5-31.4V227H50.5l31.9-30.4-17.3-18.1L1.7 239 65 300.5l17.5-17.9L51 252h185.2v198.8l-30.4-31.9-18.1 17.2 60.5 63.4 61.5-63.3-17.9-17.4-30.6 31.4V252h188.3l-31.9 30.4 17.3 18.1 63.4-60.5z" />
    </g>
);
